import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import download from 'downloadjs';
import moment from 'moment';
import QRCode from 'qrcode';
import jsPDF from 'jspdf';

const API_HEADERS = { authorization: 'authkey xB84JJ89Hd25' };
const MAX_DROPDOWN_OPTIONS = 100;
const TROLLEY_REPORT_MAX_BAG_SEARCH = 50; // HUB-8256: keep in sync with backend TrolleyReportMaxBagSearchCount
const TROLLEY_REPORT_MAX_TROLLEY_SEARCH = 50; // HUB-8256: keep in sync with backend TrolleyReportMaxTrolleySearchCount
const TROLLEY_REPORT_PAGE_SIZE = 10; // HUB-8256: keep in sync with backend TrolleyReportDefaultPageSize
const MAX_VISIBLE_CHIPS = 100;
const PRINT_CHUNK_SIZE = 25;

const TROLLEY_CONFIG_META = {
	expectedHeaders: [
		'Hub Name',
		'Trolley ID',
		'Trolley Name',
		'isActive',
		'Trolley QR',
	],
		optionalHeaders: [
			'Trolley Type',
			'Trolley Capacity',
		],
	sampleFileName: 'Trolley_Config_Sample.csv',
		sampleColumns: [
			{ key: 'hubName', header: 'Hub Name' },
			{ key: 'trolleyId', header: 'Trolley ID' },
			{ key: 'trolleyName', header: 'Trolley Name' },
			{ key: 'isActive', header: 'isActive' },
			{ key: 'trolleyQr', header: 'Trolley QR' },
		],
		sampleData: [{
			hubName: 'Dummy/Hub',
			trolleyId: 'T001',
			trolleyName: 'T001ONE-PNQ/BAN-90',
			isActive: 'false',
			trolleyQr: 'Dummy/Hub-T0012-bagout',
		}],
	idField: 'trolleyId',
	nameField: 'trolleyName',
	hubField: 'hubName',
	qrKey: 'trolleyQr',
	typeKey: 'trolleyType',
	capacityKey: 'trolleyCapacity',
	idLabel: 'Trolley ID',
	nameLabel: 'Trolley Name',
	qrHeader: 'Trolley QR',
	typeHeader: 'Trolley Type',
	capacityHeader: 'Trolley Capacity',
	uploadColumns: [
		{ key: 'hubName', header: 'Hub Name' },
		{ key: 'trolleyId', header: 'Trolley ID' },
		{ key: 'trolleyName', header: 'Trolley Name' },
		{ key: 'isActive', header: 'isActive' },
		{ key: 'trolleyQr', header: 'Trolley QR' },
		{ key: 'trolleyType', header: 'Trolley Type' },
		{ key: 'trolleyCapacity', header: 'Trolley Capacity' },
	],
};

const AREA_CONFIG_META = {
	expectedHeaders: [
		'Hub Name',
		'Area ID',
		'Area Name',
		'isActive',
		'Area QR',
		'Area Type',
	],
	sampleFileName: 'Area_Config_Sample.csv',
	sampleColumns: [
		{ key: 'hubName', header: 'Hub Name' },
		{ key: 'areaId', header: 'Area ID' },
		{ key: 'areaName', header: 'Area Name' },
		{ key: 'isActive', header: 'isActive' },
		{ key: 'areaQr', header: 'Area QR' },
		{ key: 'areaType', header: 'Area Type' },
	],
	sampleData: [{
		hubName: 'Dummy/Hub',
		areaId: 'A001',
		areaName: 'Origin Area A001',
		isActive: 'false',
		areaQr: 'Dummy/Hub-A001',
		areaType: 'ORIGIN',
	}],
	idField: 'areaId',
	nameField: 'areaName',
	hubField: 'hubName',
	qrKey: 'areaQr',
	typeKey: 'areaType',
	idLabel: 'Area ID',
	nameLabel: 'Area Name',
	qrHeader: 'Area QR',
	typeHeader: 'Area Type',
	uploadColumns: [
		{ key: 'hubName', header: 'Hub Name' },
		{ key: 'areaId', header: 'Area ID' },
		{ key: 'areaName', header: 'Area Name' },
		{ key: 'isActive', header: 'isActive' },
		{ key: 'areaQr', header: 'Area QR' },
		{ key: 'areaType', header: 'Area Type' },
	],
};

export default {
	name: 'TrolleyConfigComponent',
	components: {
		VueElementLoading,
		Paginate,
		Multiselect,
		download
	},
	data: function() {
		return {
			currentHubId: '',
			currentHubName: '',
			createdBy: '',
			isLoadingUpload: false,
			isLoadingConfigData: false,
			isLoadingPrint: false,
			failed: [],
			configDataList: [],
			pageNo: 0,
			pageSize: 10,
			pageCount: 0,
			totalRows: 0,
			configFile: '',
			isdisableupload: false,
			configType: 'trolley',
			currentTab: 'config',
			tabs: [
				{ key: 'config', value: 'Trolley / Area Config' },
				{ key: 'history', value: 'History' },
				{ key: 'print', value: 'Print QR Code Sticker' },
				{ key: 'report', value: 'Trolley Report', trolleyOnly: true },
			],
			fileDetails: [],
			isLoadingHistory: false,
			historyPageNo: 0,
			historyPageSize: 10,
			historyTotalRows: 0,
			historyPageCount: 0,
			reportMode: 'trolley',
			isLoadingReport: false,
			eligibleTrolleys: [],
			selectedTrolleys: [],
			lastSearchedMovementIds: [],
			trolleyBags: [],
			trolleyBagPageNo: 0,
			trolleyBagPageSize: TROLLEY_REPORT_PAGE_SIZE,
			trolleyBagTotalRows: 0,
			bagSearchInput: '',
			bagSearchResults: [],
			bagSearchPageNo: 0,
			bagSearchPageSize: TROLLEY_REPORT_PAGE_SIZE,
			bagSearchTotalRows: 0,
			lastBagSearchIds: [],
			statusModalShow: false,
			selectedConfigRow: null,
			printDataCache: [],
			qrOptions: [],
			selectedQrItems: [],
			checkAllQr: false,
			qrPageNo: 0,
			qrPageSize: 10,
			printLoadingMessage: '',
			qrSearchQuery: '',
			qrSearchTimeout: null,
		}
	},
	created: function() {},
	computed: {
		configMeta: function() {
			return this.configType === 'area' ? AREA_CONFIG_META : TROLLEY_CONFIG_META;
		},
		configTypeLabel: function() {
			return this.configType === 'area' ? 'Area Config' : 'Trolley Config';
		},
		listColumnCount: function() {
			return this.configType === 'area' ? 8 : 7;
		},
		visibleTabs: function() {
			return this.tabs.filter(tab => !tab.trolleyOnly || this.configType === 'trolley');
		},
		canSearchTrolleysReport: function() {
			return this.selectedTrolleys.length > 0 && !this.isLoadingReport;
		},
		trolleySearchSummaries: function() {
			if (!this.lastSearchedMovementIds.length) {
				return [];
			}
			const searchedIds = new Set(this.lastSearchedMovementIds.map(id => String(id)));
			return this.eligibleTrolleys.filter(
				trolley => searchedIds.has(String(trolley.movementId))
			);
		},
		showTrolleyIdInReport: function() {
			return this.lastSearchedMovementIds.length > 1;
		},
		trolleyBagColumnCount: function() {
			return this.showTrolleyIdInReport ? 8 : 7;
		},
		bagSearchColumnCount: function() {
			return 10;
		},
		trolleyBagPageCount: function() {
			return this.trolleyBagTotalRows === 0 ?
				0 :
				Math.ceil(this.trolleyBagTotalRows / this.trolleyBagPageSize);
		},
		bagSearchPageCount: function() {
			return this.bagSearchTotalRows === 0 ?
				0 :
				Math.ceil(this.bagSearchTotalRows / this.bagSearchPageSize);
		},
		canDownloadTrolleyReport: function() {
			return this.trolleyBagTotalRows > 0 && !this.isLoadingReport;
		},
		canDownloadBagSearchReport: function() {
			return this.bagSearchTotalRows > 0 && !this.isLoadingReport;
		},
		configEndpoints: function() {
			if (this.configType === 'area') {
				return {
					fileUpload: 'areaConfig/upload',
					getConfigData: 'areaConfig/list',
					searchConfigData: 'areaConfig/search',
					toggleActive: 'areaConfig/toggleActive',
					history: 'areaConfig/history',
				};
			}
			return {
				fileUpload: 'trolleyConfig/upload',
				getConfigData: 'trolleyConfig/list',
				searchConfigData: 'trolleyConfig/search',
				toggleActive: 'trolleyConfig/toggleActive',
				history: 'trolleyConfig/history',
			};
		},
		configIdField: function() {
			return this.configMeta.idField;
		},
		configNameField: function() {
			return this.configMeta.nameField;
		},
		configIdLabel: function() {
			return this.configMeta.idLabel;
		},
		configNameLabel: function() {
			return this.configMeta.nameLabel;
		},
		allQrLabel: function() {
			return 'Select All ' + this.configMeta.qrHeader;
		},
		qrSelectionSummaryLabel: function() {
			if (!this.checkAllQr) {
				return null;
			}
			if (this.qrOptions.length > 0) {
				return `${this.allQrLabel} (${this.qrOptions.length})`;
			}
			return this.allQrLabel;
		},
		filteredQrOptions: function() {
			const query = (this.qrSearchQuery || '').trim().toLowerCase();
			if (!query) {
				return this.qrOptions;
			}
			return this.qrOptions.filter(item =>
				String(item.text).toLowerCase().includes(query)
			);
		},
		dropdownQrOptions: function() {
			return this.filteredQrOptions.slice(0, MAX_DROPDOWN_OPTIONS);
		},
		qrDropdownTruncated: function() {
			return this.filteredQrOptions.length > MAX_DROPDOWN_OPTIONS;
		},
		qrDropdownTotalCount: function() {
			return this.filteredQrOptions.length;
		},
		hasActiveQrSearch: function() {
			return (this.qrSearchQuery || '').trim().length > 0;
		},
		qrSearchActionItems: function() {
			return this.hasActiveQrSearch ? this.filteredQrOptions : this.qrOptions;
		},
		qrSearchActionCount: function() {
			return this.qrSearchActionItems.length;
		},
		displayedQrChips: function() {
			return this.selectedQrItems.slice(0, MAX_VISIBLE_CHIPS);
		},
		remainingQrChipCount: function() {
			return Math.max(0, this.selectedQrItems.length - MAX_VISIBLE_CHIPS);
		},
		hasQrSelection: function() {
			return this.checkAllQr || this.selectedQrItems.length > 0;
		},
		selectedQrIdSet: function() {
			return new Set(this.selectedQrItems.map(item => String(item.id)));
		},
		qrPreviewList: function() {
			if (!this.hasQrSelection) {
				return [];
			}
			if (this.checkAllQr) {
				return this.printDataCache.slice();
			}
			return this.selectedQrItems.map(item => item.row);
		},
		qrTotalRows: function() {
			return this.qrPreviewList.length;
		},
		qrPageCount: function() {
			return this.qrTotalRows === 0 ?
				0 :
				Math.ceil(this.qrTotalRows / this.qrPageSize);
		},
		paginatedQrPreviewList: function() {
			const start = this.qrPageNo * this.qrPageSize;
			return this.qrPreviewList.slice(start, start + this.qrPageSize);
		},
	},
	filters: {
		moment: function(date) {
			if (date == '' || date == null) {
				return '--'
			}
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		moment1: function(timestamp) {
			if (timestamp == '' || timestamp == null) {
				return '--';
			}
			// HUB-8150: history API returns IST via timestamptzAsIST (+05:30); do not re-format as UTC.
			const parsed = moment.parseZone(timestamp);
			if (!parsed.isValid()) {
				return '--';
			}
			return parsed.format('DD-MM-YYYY HH:mm:ss');
		},
	},
	beforeDestroy() {
		this.clearQrSearchTimeout();
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
		this.currentHubId = userdetail[0].HubId[0];

		this.getHubName(userdetail[0].HubId);
		this.getConfigData();
	},
	methods: {
		switchTab(tab) {
			this.currentTab = tab.key;
			if (tab.key === 'config') {
				this.getConfigData();
				return;
			}
			if (tab.key === 'history') {
				this.resetForm();
				this.historyPageNo = 0;
				this.getConfigFileHistory();
				return;
			}
			if (tab.key === 'report') {
				this.resetReport();
				this.loadEligibleTrolleys();
				return;
			}
			this.resetPrint();
			this.loadPrintData();
		},

		onConfigTypeChange() {
			this.resetForm();
			this.pageNo = 0;
			if (this.configType === 'area' && this.currentTab === 'report') {
				this.currentTab = 'config';
			}
			this.resetReport();
			if (this.currentTab === 'history') {
				this.historyPageNo = 0;
				this.getConfigFileHistory();
				return;
			}
			if (this.currentTab === 'print') {
				this.resetPrint();
				this.loadPrintData();
				return;
			}
			if (this.currentTab === 'report') {
				this.loadEligibleTrolleys();
				return;
			}
			this.getConfigData();
		},

		getConfigFileHistory() {
			this.isLoadingHistory = true;
			this.fileDetails = [];
			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + this.configEndpoints.history +
					'?currentHubId=' + this.currentHubId +
					'&pageIndex=' + this.historyPageNo +
					'&pageSize=' + this.historyPageSize,
				headers: API_HEADERS,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.fileDetails = result.data.ResponseData || [];
					this.historyTotalRows = result.data.TotalCount || 0;
					this.historyPageCount = this.historyTotalRows === 0 ?
						0 :
						Math.ceil(this.historyTotalRows / this.historyPageSize);
				} else if (result.data.ResultCode == 101) {
					this.fileDetails = [];
					this.historyTotalRows = 0;
					this.historyPageCount = 0;
				} else {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
				}
				this.isLoadingHistory = false;
			}, error => {
				this.isLoadingHistory = false;
				console.error(error);
				this.$alertify.error('Error Occured');
			});
		},

		getHistoryPaginationData(pageNum) {
			this.historyPageNo = pageNum - 1;
			this.getConfigFileHistory();
		},


		onReportModeChange() {
			this.resetReportResults();
			if (this.reportMode === 'trolley') {
				this.loadEligibleTrolleys();
			}
		},

		getTrolleyDropdownLabel(trolley) {
			return `${trolley.trolleyId} — ${trolley.movementStatus} (${trolley.bagCount} bags)`;
		},

		formatReportDate(value) {
			if (!value) {
				return '--';
			}
			return moment(value).format('DD-MM-YYYY HH:mm:ss');
		},

		resetReportResults() {
			this.selectedTrolleys = [];
			this.lastSearchedMovementIds = [];
			this.trolleyBags = [];
			this.trolleyBagPageNo = 0;
			this.trolleyBagTotalRows = 0;
			this.bagSearchResults = [];
			this.bagSearchPageNo = 0;
			this.bagSearchTotalRows = 0;
			this.lastBagSearchIds = [];
		},

		resetReport() {
			this.reportMode = 'trolley';
			this.bagSearchInput = '';
			this.eligibleTrolleys = [];
			this.resetReportResults();
		},

		loadEligibleTrolleys() {
			if (this.configType !== 'trolley' || this.currentTab !== 'report' || this.reportMode !== 'trolley') {
				return;
			}

			this.isLoadingReport = true;
			this.eligibleTrolleys = [];
			this.resetReportResults();

			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'v1/movement/report/eligible-trolleys?hubId=' + this.currentHubId,
				headers: API_HEADERS,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.eligibleTrolleys = result.data.ResponseData || [];
				} else if (result.data.ResultCode == 101) {
					this.eligibleTrolleys = [];
				} else {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
				}
				this.isLoadingReport = false;
			}, error => {
				this.isLoadingReport = false;
				console.error(error);
				this.$alertify.error('Error Occured');
			});
		},

		searchTrolleysReport() {
			if (!this.selectedTrolleys.length) {
				this.$alertify.error('Please select at least one trolley.');
				return;
			}
			if (this.selectedTrolleys.length > TROLLEY_REPORT_MAX_TROLLEY_SEARCH) {
				this.$alertify.error('Maximum ' + TROLLEY_REPORT_MAX_TROLLEY_SEARCH + ' trolleys allowed.');
				return;
			}

			this.lastSearchedMovementIds = this.selectedTrolleys.map(trolley => trolley.movementId);
			this.trolleyBagPageNo = 0;
			this.loadTrolleyBags(0);
		},

		loadTrolleyBags(pageNo) {
			if (!this.lastSearchedMovementIds.length) {
				return;
			}

			if (pageNo !== undefined) {
				this.trolleyBagPageNo = pageNo;
			}

			this.isLoadingReport = true;
			this.trolleyBags = [];

			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'v1/movement/report/trolleys-search?hubId=' + this.currentHubId +
					'&movementIds=' + encodeURIComponent(this.lastSearchedMovementIds.join(',')) +
					'&pageIndex=' + this.trolleyBagPageNo +
					'&pageSize=' + this.trolleyBagPageSize,
				headers: API_HEADERS,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.trolleyBags = result.data.ResponseData || [];
					this.trolleyBagTotalRows = result.data.TotalCount || 0;
				} else if (result.data.ResultCode == 101) {
					this.trolleyBags = [];
					this.trolleyBagTotalRows = 0;
					this.$alertify.error(result.data.ReturnMessage || 'No bags found for the selected trolley movement(s).');
				} else {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
				}
				this.isLoadingReport = false;
			}, error => {
				this.isLoadingReport = false;
				console.error(error);
				this.$alertify.error('Error Occured');
			});
		},

		getTrolleyBagPaginationData(pageNum) {
			this.loadTrolleyBags(pageNum - 1);
		},

		parseBagSearchInput() {
			const seen = new Set();
			const bagIds = [];
			String(this.bagSearchInput || '')
				.split(',')
				.forEach(part => {
					const bagId = String(part).trim().toLowerCase();
					if (bagId && !seen.has(bagId)) {
						seen.add(bagId);
						bagIds.push(bagId);
					}
				});
			return bagIds;
		},

		searchBagsReport() {
			const bagIds = this.parseBagSearchInput();
			if (!bagIds.length) {
				this.$alertify.error('Please enter at least one bag number.');
				return;
			}
			if (bagIds.length > TROLLEY_REPORT_MAX_BAG_SEARCH) {
				this.$alertify.error('Maximum ' + TROLLEY_REPORT_MAX_BAG_SEARCH + ' bag numbers allowed.');
				return;
			}

			this.lastBagSearchIds = bagIds;
			this.bagSearchPageNo = 0;
			this.loadBagSearchPage(0);
		},

		loadBagSearchPage(pageNo) {
			if (!this.lastBagSearchIds.length) {
				return;
			}

			this.bagSearchPageNo = pageNo;
			this.isLoadingReport = true;
			this.bagSearchResults = [];

			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'v1/movement/report/bags-search?hubId=' + this.currentHubId +
					'&bagIds=' + encodeURIComponent(this.lastBagSearchIds.join(',')) +
					'&pageIndex=' + this.bagSearchPageNo +
					'&pageSize=' + this.bagSearchPageSize,
				headers: API_HEADERS,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.bagSearchResults = result.data.ResponseData || [];
					this.bagSearchTotalRows = result.data.TotalCount || 0;
				} else if (result.data.ResultCode == 101) {
					this.bagSearchResults = [];
					this.bagSearchTotalRows = 0;
					this.$alertify.error(result.data.ReturnMessage || 'No records found.');
				} else {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
				}
				this.isLoadingReport = false;
			}, error => {
				this.isLoadingReport = false;
				console.error(error);
				this.$alertify.error('Error Occured');
			});
		},

		getBagSearchPaginationData(pageNum) {
			this.loadBagSearchPage(pageNum - 1);
		},

		resetTrolleySearch() {
			this.selectedTrolleys = [];
			this.lastSearchedMovementIds = [];
			this.trolleyBags = [];
			this.trolleyBagPageNo = 0;
			this.trolleyBagTotalRows = 0;
		},

		resetBagSearch() {
			this.bagSearchInput = '';
			this.bagSearchResults = [];
			this.bagSearchPageNo = 0;
			this.bagSearchTotalRows = 0;
			this.lastBagSearchIds = [];
		},

		async downloadTrolleyReportCsv() {
			if (!this.lastSearchedMovementIds.length || !this.canDownloadTrolleyReport) {
				return;
			}

			this.isLoadingReport = true;

			try {
				const result = await axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'v1/movement/report/trolleys-search?hubId=' + this.currentHubId +
						'&movementIds=' + encodeURIComponent(this.lastSearchedMovementIds.join(',')) +
						'&forExport=true',
					headers: API_HEADERS,
				});

				if (result.data.ResultCode != 100) {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
					return;
				}

				const bags = result.data.ResponseData || [];
				if (!bags.length) {
					this.$alertify.error('No records found to download.');
					return;
				}

				const csvRows = bags.map(bag => ({
					trolleyId: bag.trolleyId || '',
					movementStatus: bag.movementStatus || '',
					fromAreaId: bag.fromAreaId || '',
					bagId: bag.bagId || '',
					status: bag.status || '',
					createdBy: bag.createdBy || '',
					createdDate: bag.createdDate || '',
					lastModifiedBy: bag.lastModifiedBy || '',
					lastModifiedDate: bag.lastModifiedDate || ''
				}));
				const csvFields = {
					trolleyId: 'Trolley ID',
					movementStatus: 'Movement Status',
					fromAreaId: 'From Area',
					bagId: 'Bag No',
					status: 'Status',
					createdBy: 'Loaded By',
					createdDate: 'Loaded At',
					lastModifiedBy: 'Last Modified By',
					lastModifiedDate: 'Last Modified At'
				};
				const filename = 'Trolley_Report_' + moment().format('DDMMYYYY_HHmmss') + '.csv';
				await this.jsonToCSV(filename, csvRows, csvFields, ['createdDate', 'lastModifiedDate'], [], false);
			} catch (error) {
				console.error(error);
				this.$alertify.error('Error Occured');
			} finally {
				this.isLoadingReport = false;
			}
		},

		async downloadBagSearchReportCsv() {
			if (!this.lastBagSearchIds.length || !this.canDownloadBagSearchReport) {
				return;
			}

			this.isLoadingReport = true;

			try {
				const result = await axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'v1/movement/report/bags-search?hubId=' + this.currentHubId +
						'&bagIds=' + encodeURIComponent(this.lastBagSearchIds.join(',')) +
						'&forExport=true',
					headers: API_HEADERS,
				});

				if (result.data.ResultCode != 100) {
					this.$alertify.error(result.data.ReturnMessage || 'Error Occured');
					return;
				}

				const rows = result.data.ResponseData || [];
				if (!rows.length) {
					this.$alertify.error('No records found to download.');
					return;
				}

				const csvRows = rows.map(row => ({
					bagId: row.bagId || '',
					trolleyId: row.trolleyId || '',
					movementStatus: row.movementStatus || '',
					fromAreaId: row.fromAreaId || '',
					toAreaId: row.toAreaId || '',
					bagStatus: row.bagStatus || '',
					loadedBy: row.loadedBy || '',
					loadedAt: row.loadedAt || '',
					movementStartedAt: row.movementStartedAt || ''
				}));
				const csvFields = {
					bagId: 'Bag No',
					trolleyId: 'Trolley ID',
					movementStatus: 'Movement Status',
					fromAreaId: 'From Area',
					toAreaId: 'To Area',
					bagStatus: 'Bag Status',
					loadedBy: 'Loaded By',
					loadedAt: 'Loaded At',
					movementStartedAt: 'Movement Started At'
				};
				const filename = 'Bags_Search_Report_' + moment().format('DDMMYYYY_HHmmss') + '.csv';
				await this.jsonToCSV(filename, csvRows, csvFields, ['loadedAt', 'movementStartedAt'], [], false);
			} catch (error) {
				console.error(error);
				this.$alertify.error('Error Occured');
			} finally {
				this.isLoadingReport = false;
			}
		},

		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: API_HEADERS,
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.currentHubName = result.data.ResponseData[0].HubName
					}
				}, error => {
					console.error(error)
				})
		},

		getConfigData() {
			this.isLoadingConfigData = true;
			this.configDataList = [];

			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + this.configEndpoints.getConfigData +
						'?hubId=' + this.currentHubId +
						'&pageIndex=' + this.pageNo +
						'&pageSize=' + this.pageSize,
					headers: API_HEADERS,
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.configDataList = result.data.ResponseData || [];
						this.totalRows = result.data.TotalCount || 0;
						this.pageCount = this.totalRows === 0 ?
							0 :
							Math.ceil(this.totalRows / this.pageSize);
					} else if (result.data.ResultCode == 101 || result.data.TotalCount === 0) {
						this.configDataList = [];
						this.totalRows = 0;
						this.pageCount = 0;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoadingConfigData = false;
				}, error => {
					this.isLoadingConfigData = false;
					console.error(error);
					this.$alertify.error('Error Occured');
				})
		},

		buildSearchConfigUrl(searchParams) {
			let url = apiUrl.api_url_hubops + this.configEndpoints.searchConfigData +
				'?hubId=' + this.currentHubId +
				'&pageIndex=' + (searchParams.pageIndex || 0) +
				'&pageSize=' + (searchParams.pageSize || this.pageSize);

			if (searchParams.isActive !== undefined) {
				url += '&isActive=' + searchParams.isActive;
			}
			return url;
		},

		requestConfigSearch(searchParams) {
			return axios({
				method: 'GET',
				url: this.buildSearchConfigUrl(searchParams),
				headers: API_HEADERS,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					return {
						rows: result.data.ResponseData || [],
						totalCount: result.data.TotalCount || 0,
					};
				}
				if (result.data.ResultCode == 101) {
					return { rows: [], totalCount: 0 };
				}
				throw new Error(result.data.ReturnMessage || 'Search failed.');
			});
		},

		fetchAllPagedRows(requestFn, searchParams = {}) {
			const pageSize = searchParams.pageSize || this.pageSize;
			const allRows = [];

			const fetchPage = (pageIndex) => {
				return requestFn({ ...searchParams, pageIndex, pageSize }).then(({ rows, totalCount }) => {
					allRows.push(...rows);

					if (totalCount && allRows.length >= totalCount) {
						return allRows;
					}
					if (rows.length < pageSize) {
						return allRows;
					}
					return fetchPage(pageIndex + 1);
				});
			};

			return fetchPage(0);
		},

		searchAllConfigData(searchParams) {
			return this.fetchAllPagedRows(
				params => this.requestConfigSearch(params),
				searchParams
			);
		},

		loadPrintData() {
			this.isLoadingPrint = true;
			this.printLoadingMessage = 'Loading QR codes...';
			this.printDataCache = [];
			this.qrOptions = [];
			this.selectedQrItems = [];
			this.checkAllQr = false;
			this.qrSearchQuery = '';
			this.qrPageNo = 0;

			this.searchAllConfigData({ isActive: true }).then(rows => {
				this.printDataCache = (rows || []).filter(item => this.getQrValue(item));
				this.qrOptions = this.printDataCache.map(item => ({
					id: String(this.getConfigIdValue(item)),
					text: String(this.getQrValue(item)),
					row: item,
				}));
				this.isLoadingPrint = false;
				this.printLoadingMessage = '';
			}, error => {
				console.error(error);
				this.isLoadingPrint = false;
				this.printLoadingMessage = '';
				this.printDataCache = [];
				this.qrOptions = [];
				this.$alertify.error('Error Occured');
			});
		},

		getQrPaginationData(pageNum) {
			this.qrPageNo = pageNum - 1;
		},

		clearQrSearchTimeout() {
			if (this.qrSearchTimeout) {
				clearTimeout(this.qrSearchTimeout);
				this.qrSearchTimeout = null;
			}
		},

		onQrSearchChange(query) {
			this.clearQrSearchTimeout();
			this.qrSearchTimeout = setTimeout(() => {
				this.qrSearchQuery = (query || '').trim();
				this.qrSearchTimeout = null;
			}, 250);
		},

		isQrSelected(option) {
			if (this.checkAllQr) {
				return true;
			}
			console.log("option",option);
			return this.selectedQrIdSet.has(String(option.id));
		},

		onQrOptionClick(option) {
			if (this.checkAllQr) {
				return;
			}

			const optionId = String(option.id);
			if (this.isQrSelected(option)) {
				this.selectedQrItems = this.selectedQrItems.filter(
					item => String(item.id) !== optionId
				);
			} else {
				const match = this.qrOptions.find(item => String(item.id) === optionId) || option;
				this.selectedQrItems = this.selectedQrItems.concat([match]);
			}
			this.syncCheckAllQr();
		},

		removeSelectedQr(option) {
			this.checkAllQr = false;
			this.selectedQrItems = this.selectedQrItems.filter(
				item => String(item.id) !== String(option.id)
			);
			this.qrPageNo = 0;
		},

		clearAllQrSelection() {
			this.checkAllQr = false;
			this.selectedQrItems = [];
			this.qrSearchQuery = '';
			this.qrPageNo = 0;
		},

		toggleCheckAllQr() {
			if (this.qrOptions.length === 0) {
				return;
			}
			if (this.checkAllQr) {
				this.clearAllQrSelection();
				return;
			}
			if (this.selectedQrItems.length === this.qrOptions.length) {
				this.clearAllQrSelection();
				return;
			}
			this.checkAllQr = true;
			this.selectedQrItems = [];
			this.qrPageNo = 0;
		},

		selectAllQrFromSearch() {
			if (this.checkAllQr || this.qrOptions.length === 0) {
				return;
			}

			const items = this.qrSearchActionItems;
			if (items.length === 0) {
				return;
			}

			if (!this.hasActiveQrSearch || items.length === this.qrOptions.length) {
				this.checkAllQr = true;
				this.selectedQrItems = [];
				this.qrPageNo = 0;
				return;
			}

			const selectedSet = this.selectedQrIdSet;
			const toAdd = items.filter(item => !selectedSet.has(String(item.id)));
			if (toAdd.length > 0) {
				this.selectedQrItems = this.selectedQrItems.concat(toAdd);
			}
			this.syncCheckAllQr();
		},

		deselectAllQrFromSearch() {
			if (!this.hasActiveQrSearch || this.checkAllQr) {
				return;
			}

			const filteredIdSet = new Set(
				this.filteredQrOptions.map(item => String(item.id))
			);
			this.selectedQrItems = this.selectedQrItems.filter(
				item => !filteredIdSet.has(String(item.id))
			);
			this.syncCheckAllQr();
		},

		syncCheckAllQr() {
			if (this.checkAllQr) {
				return;
			}
			if (this.qrOptions.length > 0 &&
				this.selectedQrItems.length === this.qrOptions.length) {
				this.checkAllQr = true;
				this.selectedQrItems = [];
			}
			this.qrPageNo = 0;
		},

		getPaginationData(pageNum) {
			this.pageNo = pageNum - 1;
			this.getConfigData();
		},

		getHubNameValue(row) {
			return row[this.configMeta.hubField] || row.facilityName || row.hubName || '';
		},

		getConfigIdValue(row) {
			return row[this.configIdField]
				|| row.trolleyId
				|| row.areaCode
				|| row.areaId
				|| '';
		},

		getConfigNameValue(row) {
			return row[this.configNameField] || '';
		},

		getQrValue(row) {
			return row[this.configMeta.qrKey] || row.qr_string || '';
		},

		getTypeValue(row) {
			return row[this.configMeta.typeKey] || '';
		},

		getCapacityValue(row) {
			if (!this.configMeta.capacityKey) {
				return '';
			}
			const value = row[this.configMeta.capacityKey];
			return value === null || value === undefined ? '' : value;
		},

		openStatusModal(row) {
			this.selectedConfigRow = row;
			this.statusModalShow = true;
		},

		closeStatusModal() {
			this.statusModalShow = false;
			this.selectedConfigRow = null;
		},

		toggleConfigActive() {
			if (!this.selectedConfigRow) {
				return;
			}

			const configId = this.getConfigIdValue(this.selectedConfigRow);
			if (!configId) {
				this.$alertify.error('Unable to update status. Config ID is missing.');
				return;
			}

			this.isLoadingConfigData = true;
			this.statusModalShow = false;

			const payload = {
				hubId: Number(this.selectedConfigRow.hubId || this.currentHubId),
				isActive: !this.selectedConfigRow.isActive,
				updatedBy: this.createdBy
			};
			payload[this.configIdField] = String(configId);

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + this.configEndpoints.toggleActive,
					data: payload,
					headers: API_HEADERS,
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						this.getConfigData();
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoadingConfigData = false;
					this.selectedConfigRow = null;
				}, error => {
					this.isLoadingConfigData = false;
					this.selectedConfigRow = null;
					console.error(error);
					this.$alertify.error('Error Occured');
				});
		},

		uploadConfigFile(event) {
			this.failed = [];
			this.selectedFile = event.target.elements.configFile.files[0];
			if (!this.selectedFile) {
				this.$alertify.error('Failed! Please select a file to upload.');
				return false;
			}
			if (this.selectedFile.size > 5242880) {
				this.$alertify.error('Failed! Upload Max File Size Should Not Be Greater Than 5 MB');
				return false;
			} else if (/\.(csv)$/i.test(this.selectedFile.name) || /\.(zip)$/i.test(this.selectedFile.name)) {
				this.isLoadingUpload = true;

				const fd = new FormData();
				fd.append('hubId', this.currentHubId);
				fd.append('hubName', this.currentHubName);
				fd.append('uploadedBy', this.createdBy);
				fd.append('fileData', this.selectedFile);
				fd.append('fileName', this.selectedFile.name);
				axios.post(apiUrl.api_url_hubops + this.configEndpoints.fileUpload, fd, {
						headers: {
							'Authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.$alertify.success(result.data.ReturnMessage);
							this.resetForm();
							this.pageNo = 0;
							this.getConfigData();
							if (this.currentTab === 'history') {
								this.historyPageNo = 0;
								this.getConfigFileHistory();
							}
						} else {
							this.$alertify.error(result.data.ReturnMessage);
						}

						if (result && result.data.failed && result.data.failed.length > 0) {
							this.failed = result.data.failed;
						}

						this.isLoadingUpload = false;
					}, error => {
						console.error(error)
						this.isLoadingUpload = false;
						this.$alertify.error('Error Occured');
					});
			} else {
				this.isLoadingUpload = false;
				this.$alertify.error('Failed! Please Upload Only Valid Format: .csv OR .zip');
			}
		},

		onUploadSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.uploadConfigFile(event);
					event.target.reset();
				}
			}).catch(() => {
				this.$alertify.error('Error Occured');
			});
		},

		downloadSampleConfigFile() {
			const uploadColumns = this.configMeta.sampleColumns || this.configMeta.uploadColumns;
			const csvFields = uploadColumns.reduce((fields, column) => {
				fields[column.key] = column.header;
				return fields;
			}, {});
			const sampleRow = this.configMeta.sampleData || [uploadColumns.reduce((row, column) => {
				row[column.key] = '';
				return row;
			}, {})];

			this.jsonToCSV(this.configMeta.sampleFileName, sampleRow, csvFields, [], [], false);
		},

		async exportFailedConfig() {
			this.isLoadingUpload = true;

			const uploadColumns = this.configMeta.sampleColumns || this.configMeta.uploadColumns;
			const csvFields = uploadColumns.reduce((fields, column) => {
				fields[column.key] = column.header;
				return fields;
			}, {});
			csvFields.reason = 'Reason';

			const failedData = this.failed.map((item) => {
				const row = {};
				uploadColumns.forEach((column) => {
					row[column.key] = item[column.header]
						|| item[column.key]
						|| (column.key === 'areaId' ? item['Area ID'] : '')
						|| (column.key === 'trolleyId' ? item['Trolley ID'] : '')
						|| '';
				});
				row.reason = item.Reason || item.reason || '';
				return row;
			});

			await this.jsonToCSV('failedConfig', failedData, csvFields);
			this.isLoadingUpload = false;
		},

		buildPrintLabel(row) {
			const idValue = this.getConfigIdValue(row);
			const nameValue = this.getConfigNameValue(row);
			const typeValue = this.getTypeValue(row);
			const qrValue = this.getQrValue(row);

			if (this.configType === 'area') {
				return `${this.configIdLabel}: ${idValue}\n` +
					`${this.configNameLabel}: ${nameValue}\n` +
					`${this.configMeta.typeHeader}: ${typeValue}\n` +
					`${qrValue}`;
			}

			const capacityValue = this.getCapacityValue(row);
			return `${this.configIdLabel}: ${idValue}\n` +
				`${this.configNameLabel}: ${nameValue}\n` +
				`${this.configMeta.typeHeader}: ${typeValue}\n` +
				`${this.configMeta.capacityHeader}: ${capacityValue}\n` +
				`${qrValue}`;
		},

		async printQRs() {
			if (!this.hasQrSelection) {
				this.$alertify.error('Please select at least one QR code to print.');
				return;
			}

			const STICKER = {
				boxWidth: 216,
				boxHeight: 200,
				leftX: 32,
				rightX: 334,
				startY: 65,
				rowSpacing: 260,
				qrSize: 118,
				padding: 8,
				topPadding: 12,
				labelGap: 8,
				fontSize: 7,
				lineHeight: 9,
			};

			const doc = new jsPDF('p', 'pt', 'a4');
			doc.setLineWidth(0.5);

			let leftRow = 0;
			let rightRow = 0;

			for (let i = 0; i < this.qrPreviewList.length; i++) {
				const preview = this.qrPreviewList[i];
				const qrValue = this.getQrValue(preview);
				const label = this.buildPrintLabel(preview);
				const qrUrl = await QRCode.toDataURL(qrValue, {
					width: 200,
					margin: 1,
				});

				if (i > 0 && leftRow === 3 && rightRow === 3) {
					leftRow = 0;
					rightRow = 0;
					doc.addPage();
				}

				const isLeftColumn = i % 2 === 0;
				const boxX = isLeftColumn ? STICKER.leftX : STICKER.rightX;
				const rowIndex = isLeftColumn ? leftRow : rightRow;
				const boxY = STICKER.startY + rowIndex * STICKER.rowSpacing;
				const labelWidth = STICKER.boxWidth - STICKER.padding * 2;
				const qrX = boxX + (STICKER.boxWidth - STICKER.qrSize) / 2;
				const qrY = boxY + STICKER.topPadding;
				const labelY = qrY + STICKER.qrSize + STICKER.labelGap;
				const labelAreaHeight = STICKER.boxHeight - (labelY - boxY) - STICKER.padding;
				const maxLines = Math.max(1, Math.floor(labelAreaHeight / STICKER.lineHeight));

				doc.rect(boxX, boxY, STICKER.boxWidth, STICKER.boxHeight);
				doc.addImage(qrUrl, 'PNG', qrX, qrY, STICKER.qrSize, STICKER.qrSize);
				doc.setFontSize(STICKER.fontSize);
				const wrappedLines = doc.splitTextToSize(label, labelWidth);
				const labelCenterX = boxX + STICKER.boxWidth / 2;
				doc.text(
					wrappedLines.slice(0, maxLines),
					labelCenterX,
					labelY,
					{ align: 'center' }
				);

				if (isLeftColumn) {
					leftRow++;
				} else {
					rightRow++;
				}

				if (i > 0 && i % PRINT_CHUNK_SIZE === 0) {
					await new Promise(resolve => setTimeout(resolve, 0));
				}
			}

			const filePrefix = this.configType === 'area' ? 'area-qr-codes' : 'trolley-qr-codes';
			doc.save(`${filePrefix}.pdf`);
		},

		resetPrint() {
			this.qrPageNo = 0;
			this.printDataCache = [];
			this.qrOptions = [];
			this.selectedQrItems = [];
			this.checkAllQr = false;
			this.printLoadingMessage = '';
			this.clearQrSearchTimeout();
			this.qrSearchQuery = '';
			this.$validator.reset();
			this.errors.clear();
		},

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = [], includeConfigName = true) {
			var csvData = ''

			if (includeConfigName && filename != 'failedConfig') csvData += 'Config Name' + ',' + filename + '\n';
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ','
			}
			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, '\"\"') + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}

			if(filename === "failedConfig") {
				filename += ".csv";
			}		
			return this.export(csvData, filename, 'application/csv');
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		resetForm(event) {
			this.isLoadingUpload = false;
			this.configFile = '';
			this.failed = [];
			this.$validator.reset();
			this.errors.clear();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/TrolleyConfig/TrolleyConfig.js